import React from "react";
import ReactLoading from "react-loading";

/**
 * SupportTicketForm — Sidebar destek talebi oluşturma sekmesi
 * NavbarMenu'dan çıkartıldı.
 */
const SupportTicketForm = ({ loading, onChange, onSubmit }) => {
  return (
    <>
      <h6>Yeni Destek Talebi Oluştur</h6>
      <form id="createTicketForm" onSubmit={onSubmit}>
        <div className="form-group">
          <input
            name="title"
            id="title"
            type="text"
            className="form-control"
            placeholder="Başlık"
            onChange={onChange}
          />
        </div>
        <div className="form-group">
          <textarea
            name="description"
            id="description"
            className="form-control"
            placeholder="Açıklama"
            onChange={onChange}
          />
        </div>
        <div className="form-group text-center">
          {loading ? (
            <button className="btn btn-outline-primary btn-block" disabled={true} style={{ textAlign: "-webkit-center" }}>
              Lütfen Bekleyin...
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#268bd2"></ReactLoading>
            </button>
          ) : (
            <button className="btn btn-outline-primary btn-block" type="submit">Kaydet</button>
          )}
        </div>
      </form>
    </>
  );
};

export default SupportTicketForm;
